// extracted by mini-css-extract-plugin
module.exports = {"panelHeight":"booking-payment_panelHeight__3-Cdo"};